<div class="flex flex-col w-full h-full bg-white rounded-2xl overflow-hidden">
    <!-- Header -->
    <div class="flex justify-between items-center px-6 py-5 border-b border-gray-200">
        <div class="flex items-center gap-2">
            <button mat-icon-button (click)="toggleMenu()" class="w-9 h-9 text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200">
                <mat-icon class="icon-size-6" [svgIcon]="'mat_solid:compare_arrows'"></mat-icon>
            </button>
            <h2 class="text-[20px] font-semibold font-inter text-gray-900 m-0">Configurações</h2>
        </div>
        <button mat-icon-button (click)="closeModal()" class="w-9 h-9 text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200">
            <mat-icon class="icon-size-6" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex flex-1 overflow-hidden relative">
        <!-- Backdrop overlay para mobile -->
        <div
            class="sm:block it:hidden absolute inset-0 bg-black z-40 transition-opacity duration-300"
            [ngClass]="{
                'opacity-50 pointer-events-auto': isMenuOpen,
                'opacity-0 pointer-events-none': !isMenuOpen
            }"
            (click)="toggleMenu()">
        </div>

        <!-- Sidebar Menu -->
        <div
            class="bg-gray-50 border-r border-gray-200 overflow-y-auto transition-all duration-300 flex-shrink-0 h-full p-3
                   sm:absolute sm:left-0 sm:top-0 sm:z-50
                   it:relative it:z-10"
            [ngClass]="{
                'w-[180px] sm:shadow-2xl it:shadow-none': isMenuOpen,
                'w-0 p-0 border-r-0 sm:-translate-x-full': !isMenuOpen
            }">
            <div class="flex flex-col gap-1" *ngIf="isMenuOpen">
                <div
                    *ngFor="let item of menuItems"
                    class="flex items-center px-3 py-3 rounded-xl cursor-pointer transition-all duration-200 group"
                    [class.bg-[#eff7ff]]="item.active"
                    [class.hover:bg-[#eff7ff]]="!item.active"
                    (click)="selectMenuItem(item.id)">
                    <mat-icon
                        class="icon-size-5 transition-all duration-200"
                        [class.text-[#0061ff]]="item.active"
                        [class.text-gray-900]="!item.active"
                        [class.group-hover:text-[#0061ff]]="!item.active"
                        [svgIcon]="item.icon"></mat-icon>
                    <span
                        class="ml-2 text-[14px] font-inter transition-all duration-200"
                        [class.text-[#0061ff]]="item.active"
                        [class.font-semibold]="item.active"
                        [class.font-medium]="!item.active"
                        [class.text-gray-900]="!item.active"
                        [class.group-hover:text-[#0061ff]]="!item.active">
                        {{ item.title }}
                    </span>
                </div>

                <!-- Administração (Trilha de Auditoria) — visível apenas com a
                     screen_key `aud-access`. Decisão do usuário: a Trilha de
                     Auditoria fica dentro deste modal, sem item de sidebar; a
                     tela "Saúde do Sistema" (/health) virou item de menu
                     visível na sidebar e por isso não aparece aqui. -->
                <ng-container *ngIf="canAccessAdministration">
                    <div class="px-3 pt-3 pb-1 text-[10px] uppercase tracking-widest text-gray-400 font-inter select-none">
                        Administração
                    </div>
                    <div
                        *ngFor="let item of adminMenuItems"
                        class="flex items-center px-3 py-3 rounded-xl cursor-pointer transition-all duration-200 group hover:bg-[#eff7ff]"
                        (click)="openAdminRoute(item.route)">
                        <mat-icon
                            class="icon-size-5 text-gray-900 group-hover:text-[#0061ff]"
                            [svgIcon]="item.icon"></mat-icon>
                        <span
                            class="ml-2 text-[14px] font-medium font-inter text-gray-900 group-hover:text-[#0061ff]">
                            {{ item.title }}
                        </span>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Main Content Area -->
        <div class="flex-1 overflow-hidden bg-white">
            <!-- Meus dados -->
            <personal-data *ngIf="selectedMenuItem === 'personal-data'"></personal-data>

            <!-- Segurança -->
            <security *ngIf="selectedMenuItem === 'security'"></security>

            <!-- Notificações -->
            <notifications *ngIf="selectedMenuItem === 'notifications'"></notifications>

            <!-- Preferências -->
            <!-- <div *ngIf="selectedMenuItem === 'preferences'" class="flex items-center justify-center h-full p-6">
                <p class="text-gray-500 text-center font-inter text-[14px]">
                    Conteúdo de "Preferências" será implementado aqui
                </p>
            </div> -->
        </div>

        <!-- Actions footer bar -->
        <!-- <div class="absolute flex bottom-0 left-0 right-0 p-6 w-full flex-row-reverse bg-white border-t border-gray-200 z-30">
            <div class="relative w-[118px] h-[38px]">
                <button (click)="saveSettings()" class="w-full h-full flex px-6 py-2 rounded-3xl bg-[#0061ff] hover:bg-[#2f75e7] relative cursor-pointer">
                    <span class="mr-2 font-remote font-[400] text-[15px] text-white">Salvar</span>
                    <mat-icon class="icon-size-5 text-white relative" [svgIcon]="'mat_solid:save'"></mat-icon>
                </button>
            </div>
        </div> -->
    </div>
</div>
